import cx from 'classnames';

interface TextProps {
  as?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  children?: any;
  className?: string;
  type?: 'title' | 'body';
  theme?: 'subscribe' | 'subscribe-gate' | 'subscribe-gate-bottom' | 'content' | 'navs' | 'default' | 'primary';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
  weight?: 'extralight' | 'light' | 'regular' | 'medium' | 'semibold' | 'bold' | 'black';
}

const Text = ({
  as = 'p',
  children,
  theme = 'subscribe',
  size = 'md',
  weight = 'regular',
  type,
  className = '',
}: TextProps) => {
  const textClasses = cx(
    className,

    // Font
    type === 'title' && 'wt-header-font',
    type === 'body' && 'wt-body-font',

    // Theme
    theme === 'content' && 'text-wt-text-on-background',
    theme === 'subscribe-gate' && 'text-wt-background',
    theme === 'subscribe-gate-bottom' && 'text-wt-text-on-background',
    theme === 'subscribe' && 'text-wt-text-on-subscribe-background',
    theme === 'navs' && 'text-wt-text-on-tertiary',
    theme === 'default' && 'text-gray-700',
    theme === 'primary' && 'text-wt-primary',

    // Sizing
    size === 'xs' && 'text-xs sm:text-sm',
    size === 'sm' && 'text-sm',
    size === 'md' && 'text-md',
    size === 'lg' && 'text-md sm:text-lg',
    size === 'xl' && 'text-lg sm:text-xl',
    size === '2xl' && 'text-xl sm:text-2xl',
    size === '3xl' && 'text-2xl sm:text-3xl',
    size === '4xl' && 'text-4xl',
    size === '5xl' && 'text-3xl sm:text-5xl',
    size === '6xl' && 'text-6xl',

    // Weight
    weight === 'extralight' && 'font-extralight',
    weight === 'light' && 'font-light',
    weight === 'regular' && 'font-regular',
    weight === 'medium' && 'font-medium',
    weight === 'semibold' && 'font-semibold',
    weight === 'bold' && 'font-bold',
    weight === 'black' && 'font-black',
  );

  switch (as) {
    case 'p':
      return <p className={textClasses}>{children}</p>;
    case 'div':
      return <div className={textClasses}>{children}</div>;
    case 'span':
      return <span className={textClasses}>{children}</span>;
    case 'h1':
      return <h1 className={textClasses}>{children}</h1>;
    case 'h2':
      return <h2 className={textClasses}>{children}</h2>;
    case 'h3':
      return <h3 className={textClasses}>{children}</h3>;
    case 'h4':
      return <h4 className={textClasses}>{children}</h4>;
    case 'h5':
      return <h5 className={textClasses}>{children}</h5>;
    case 'h6':
      return <h6 className={textClasses}>{children}</h6>;
    default:
      return <p className={textClasses}>{children}</p>;
  }
};

export default Text;
